import { fileDownloadAPI } from '@/api';
import { ErrorService } from '@/services/error-service.js';
import i18n from '@/common/i18n/i18n.js';

/**************** STATE *******************/
const state = {
  currentFileDownload: null
};

/**************** GETTERS *******************/
const getters = {};

/**************** MUTATIONS *******************/
const mutations = {

};

/**************** ACTIONS *******************/
const actions = {
 
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};